module.exports = __webpack_public_path__ + "static/2-c3edb6e8c633f34d03868263c221d016.jpg";